var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.flag
      ? _c("div", { staticClass: "order-title-wrap mt10" }, [
          _c("div", { staticClass: "swb-back-row" }, [
            _c("div", { staticClass: "order-title mb10" }, [
              _c("div", { staticClass: "order-title-content fl" }, [
                _c("ul", { staticClass: "order-status" }, [
                  _c("li", {}, [
                    _vm._v("供应商名称：" + _vm._s(_vm.contranct.sndPartyName))
                  ]),
                  _vm._v(" "),
                  _c("li", {}, [
                    _vm._v("系统合同编号：" + _vm._s(_vm.contranct.no))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v("支付方式:" + _vm._s(_vm.contranct.payWayName))
                  ]),
                  _vm._v(" "),
                  _vm.contranct.confirmed && !_vm.contranct.fullfilled
                    ? _c("li", {}, [_vm._v("合同状态：履约中")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contranct.fullfilled && !_vm.contranct.checked
                    ? _c("li", {}, [_vm._v("合同状态：履约完成")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contranct.checked
                    ? _c("li", {}, [_vm._v("合同状态：已验收")])
                    : _vm._e()
                ])
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "block-container mt10" }, [
      _c(
        "div",
        { staticClass: "swb-back-row" },
        [
          _c("swb-goods-order-search", {
            ref: "query_model",
            staticClass: "mb10",
            attrs: { no: _vm.no, isContract: true, contractId: _vm.contractId },
            on: { showSearch: _vm.searchMethod }
          }),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "orders-list-container" }, [
            _c(
              "table",
              { staticClass: "orders-list-panel1" },
              [
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _vm._l(_vm.goodsOrderList, function(goodsOrder, index) {
                  return _vm.goodsOrderList != null &&
                    _vm.goodsOrderList.length > 0
                    ? _c("tbody", { staticClass: "orders-body" }, [
                        _vm._m(3, true),
                        _vm._v(" "),
                        _c("tr", { staticClass: "abstract-row" }, [
                          _c("td", { attrs: { colspan: "6" } }, [
                            _c(
                              "div",
                              { staticClass: "abstract-content" },
                              [
                                _c("span", { staticClass: "mr10" }, [
                                  _vm._v("订单号："),
                                  _c("a", [_vm._v(_vm._s(goodsOrder.no))])
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "mr10" }, [
                                  _vm._v("合同单号："),
                                  _c("a", [
                                    _vm._v(_vm._s(goodsOrder.contractNo))
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "mr10" }, [
                                  _vm._v(_vm._s(goodsOrder.createTime))
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "mr10" }, [
                                  _vm._v(
                                    "商家名称：" +
                                      _vm._s(goodsOrder.buyerComName)
                                  )
                                ]),
                                _vm._v(" "),
                                goodsOrder.trackPhaseName != null
                                  ? _c("span", { staticClass: "mr10" }, [
                                      _vm._v(
                                        "计划阶段：" +
                                          _vm._s(goodsOrder.trackPhaseName)
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: goodsOrder.manualAllocFlag
                                        ? "success"
                                        : "danger"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        goodsOrder.manualAllocFlag
                                          ? "手工配货"
                                          : "自动配货"
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                goodsOrder.cgVoucherId != -1
                                  ? _c("el-tag", { staticClass: "success" }, [
                                      _vm._v("请购")
                                    ])
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            goodsOrder.proxied
                              ? _c("div", { staticClass: "table-tips order" })
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "info-row" }, [
                          _c(
                            "td",
                            _vm._l(goodsOrder.itemList, function(
                              goodsOrderItem,
                              index
                            ) {
                              return goodsOrder.itemList != null &&
                                goodsOrder.itemList.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "goods-info-block mt10" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "goods-item clearfix" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "good-img" },
                                            [
                                              _c("img", {
                                                staticClass: "wh100",
                                                attrs: {
                                                  src:
                                                    goodsOrderItem.skuDefaultImageUrl
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "good-msg" },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "ellipsis-2 font12 align-left"
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        goodsOrderItem.title
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(
                                                    "  \n                                            "
                                                  ),
                                                  _vm._l(
                                                    goodsOrderItem.skuSpecVals,
                                                    function(
                                                      skuSpecVal,
                                                      index
                                                    ) {
                                                      return goodsOrderItem.skuSpecVals !=
                                                        null &&
                                                        goodsOrderItem
                                                          .skuSpecVals.length >
                                                          0
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "\n                                            " +
                                                                _vm._s(
                                                                  skuSpecVal.specName
                                                                ) +
                                                                "：" +
                                                                _vm._s(
                                                                  skuSpecVal.specVal
                                                                ) +
                                                                "  \n                                            "
                                                            )
                                                          ])
                                                        : _vm._e()
                                                    }
                                                  )
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "mt5 align-left"
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("品牌：")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        goodsOrderItem.brandName
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "goods-number font-gray1"
                                        },
                                        [
                                          _vm._v(
                                            "x " +
                                              _vm._s(goodsOrderItem.quantity)
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "clr" })
                                    ]
                                  )
                                : _vm._e()
                            })
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _c("div", [
                              _c("div", { staticClass: "font14" }, [
                                _vm._v(
                                  "联系人：" +
                                    _vm._s(goodsOrder.buyerComContactName)
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "font14" }, [
                                _vm._v(
                                  "联系方式：" +
                                    _vm._s(goodsOrder.buyerComContactTel)
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("div", { staticClass: "font-gray1" }, [
                              _c("div", { staticClass: "font14 font-gray2" }, [
                                _vm._v(
                                  "总额：¥" + _vm._s(goodsOrder.totalAmount)
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("div", { staticClass: "font14 font-gray2" }, [
                              _vm._v(_vm._s(goodsOrder.state))
                            ]),
                            _vm._v(" "),
                            _vm.checkActionPerm("view_detail")
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.toGoodsOrderInfo(
                                          goodsOrder.id,
                                          goodsOrder.manualAllocFlag,
                                          goodsOrder.cancelled
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "icon iconfont" }),
                                    _c("span", [_vm._v("订单详情")])
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            goodsOrder.shipState == 0
                              ? _c(
                                  "div",
                                  { staticClass: "font14 font-gray2" },
                                  [_vm._v("未发货")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            goodsOrder.shipState == 1 &&
                            goodsOrder.recvState == 0
                              ? _c(
                                  "div",
                                  { staticClass: "font14 font-gray2" },
                                  [_vm._v("已部分发货")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            goodsOrder.shipState == 1 &&
                            goodsOrder.recvState == 1
                              ? _c(
                                  "div",
                                  { staticClass: "font14 font-gray2" },
                                  [_vm._v("已部分收货")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            goodsOrder.shipState == 1 &&
                            goodsOrder.recvState == 2
                              ? _c(
                                  "div",
                                  { staticClass: "font14 font-gray2" },
                                  [_vm._v("已全部收货")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            goodsOrder.shipState == 2 &&
                            goodsOrder.recvState == 0
                              ? _c(
                                  "div",
                                  { staticClass: "font14 font-gray2" },
                                  [_vm._v("已全部发货")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            goodsOrder.shipState == 2 &&
                            goodsOrder.recvState == 1
                              ? _c(
                                  "div",
                                  { staticClass: "font14 font-gray2" },
                                  [_vm._v("已部分收货")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            goodsOrder.shipState == 2 &&
                            goodsOrder.recvState == 2
                              ? _c(
                                  "div",
                                  { staticClass: "font14 font-gray2" },
                                  [_vm._v("已全部收货")]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm.checkActionPerm("cancel") &&
                            goodsOrder.proxied &&
                            !goodsOrder.cancelled &&
                            goodsOrder.shipState == 0 &&
                            !_vm.contranct.closed
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "swb-btn-link",
                                      on: {
                                        click: function($event) {
                                          _vm.doCancelGoodsOrderById(
                                            goodsOrder.id
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("取消")]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.contranct.closed
                              ? _c("div", [
                                  _vm.checkActionPerm("initiate_complaint")
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "swb-btn swb-btn-link",
                                          on: {
                                            click: function($event) {
                                              _vm.complaintSave(goodsOrder.id)
                                            }
                                          }
                                        },
                                        [_vm._v("发起投诉")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.checkActionPerm("allocation_of_cargo") &&
                                  !goodsOrder.cancelled
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "swb-btn swb-btn-link",
                                          on: {
                                            click: function($event) {
                                              _vm.toPeiHuo(goodsOrder.id)
                                            }
                                          }
                                        },
                                        [_vm._v("去配货")]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ])
                        ])
                      ])
                    : _vm._e()
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block pagination-layout" },
            [
              _c("el-pagination", {
                staticClass: "mt10",
                attrs: {
                  background: "",
                  "page-size": _vm.pageSize,
                  "page-sizes": _vm.pageSizes,
                  "current-page": _vm.pageNumber,
                  total: _vm.totalCount,
                  layout: "total, sizes, prev, pager, next, jumper"
                },
                on: {
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.flag
      ? _c("div", { staticClass: "form-toolbar" }, [
          _c(
            "button",
            {
              staticClass: "swb-btn swb-btn-small swb-btn-primary",
              on: { click: _vm.prevContract }
            },
            [_vm._v("返回")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "order-search-container" }, [
      _c("a", { staticClass: "all-order" }, [_vm._v("全部订单")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "550" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "200" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "150" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "100" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "100" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "100" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "orders-header" }, [
      _c("tr", {}, [
        _c("th", [_vm._v("订单详情")]),
        _vm._v(" "),
        _c("th", [_vm._v("收货信息")]),
        _vm._v(" "),
        _c("th", [_vm._v("金额")]),
        _vm._v(" "),
        _c("th", [_vm._v("交易状态")]),
        _vm._v(" "),
        _c("th", [_vm._v("交付状态")]),
        _vm._v(" "),
        _c("th", [_vm._v("操作")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "blank-row" }, [
      _c("td", { attrs: { colspan: "6" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4756c9e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4756c9e6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/GoodsOrderList.vue
// module id = 2055
// module chunks = 1